export const SET_CLIENT = 'CLIENTS/SET_CLIENT';
export const SET_ALL_CLIENTS = 'CLIENTS/SET_ALL_CLIENTS';
export const SELECT_CLIENT = 'CLIENT_SELECTION/SELECT_CLIENT';
export const HANDLE_LOADING = 'CLIENTS/HANDLE_LOADING';
export const SET_CLIENTS_FILTER = 'CLIENTS/SET_CLIENTS_FILTER';